import React from 'react';
import ExternalLinkCard from 'src/common/components/external-link';
import { useStepEditorContext } from 'src/store/step-editor';

interface Props {
  onExternalLinkNavigate?: () => void;
  disabled?: boolean;
}

const StepEditorExternalLink = (props: Props) => {
  const { externalLink } = useStepEditorContext((state) => state.previewObject);
  const link = {
    ...externalLink,
    title: externalLink['title'] || externalLink['name'],
  };

  return <ExternalLinkCard isThumbnailHidden={link.hide_image} link={link} {...props} />;
};

export default StepEditorExternalLink;
